import { PrivacyPolicy, TermsOfUse } from '@strata/react-page-templates';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { Automations } from 'components/admin/automations/Automations';
import { PrescriberListDetails } from 'components/admin/prescriberLists/PrescriberListDetails';
import { PrescriberLists } from 'components/admin/prescriberLists/PrescriberLists';
import { StateListDetails } from 'components/admin/stateLists/StateListDetails';
import { StateLists } from 'components/admin/stateLists/StateLists';
import { UserAccountFormPage } from 'components/admin/userAccounts/UserAccountFormPage';
import { UserAccountsListPage } from 'components/admin/userAccounts/UserAccountsListPage';
import { AuthCallback } from 'components/auth/AuthCallback';
import { LoggedOut } from 'components/auth/LoggedOut';
import { RequireAuth } from 'components/auth/RequireAuth';
import { ClaimDetailsPage } from 'components/claims/ClaimDetailsPage';
import { ClaimsListPage } from 'components/claims/ClaimsListPage';
import { DeclinedReferralListPage } from 'components/declinedReferrals/DeclinedReferralListPage';
import { DetermineReferralLocation } from 'components/DetermineReferralLocation';
import { ExpiredReferralListPage } from 'components/expiredReferrals/ExpiredReferralListPage';
import { HighmarkWholecarePayerNotes } from 'components/HighmarkWholecarePayerNotes';
import { Home } from 'components/home/Home';
import { UpdatesHistoryScreen } from 'components/home/UpdatesHistoryScreen';
import { KnowledgeCenterPage } from 'components/knowledgeCenter/KnowledgeCenterPage';
import { LiveReferralDetailsPage } from 'components/liveReferrals/LiveReferralDetailsPage';
import { LiveReferralsListPage } from 'components/liveReferrals/LiveReferralsListPage';
import { LostReferralsListPage } from 'components/lostReferrals/LostReferralsListPage';
import { AllMessages } from 'components/messages/AllMessages';
import { ConversationRedirect } from 'components/messages/ConversationRedirect';
import { TermsAndConditions } from 'components/TermsAndConditions';
import { UpcomingReferralsListPage } from 'components/upcomingReferrals/UpcomingReferralsListPage';
import { ClaimSubmissionForm } from 'components/wonReferrals/claimSubmission/ClaimSubmissionForm';
import { WonReferralDetailsPage } from 'components/wonReferrals/WonReferralDetailsPage';
import { WonReferralsListPage } from 'components/wonReferrals/WonReferralsListPage';
import { WorklistPage } from 'components/worklist/WorklistPage';
import { SupplierFeatures } from 'services/FeatureFlags';
import { AppRoutes } from 'services/routes';

export const App = () => (
    <BrowserRouter basename="/">
        <Routes>
            <Route path={AppRoutes.callback} element={<AuthCallback />} />
            <Route path={AppRoutes.loggedOut} element={<LoggedOut />} />
            <Route element={<RequireAuth />}>
                <Route path={AppRoutes.home} element={<Home />} />
                <Route path={AppRoutes.worklist} element={<WorklistPage />} />
                <Route path={AppRoutes.referralDetails()} element={<DetermineReferralLocation />} />
                <Route path={AppRoutes.liveReferrals} element={<LiveReferralsListPage />} />
                <Route
                    path={AppRoutes.liveReferralDetails()}
                    element={<LiveReferralDetailsPage />}
                />
                <Route path={AppRoutes.wonReferrals} element={<WonReferralsListPage />} />
                <Route path={AppRoutes.wonReferralDetails()} element={<WonReferralDetailsPage />} />
                <Route path={AppRoutes.upcomingReferrals} element={<UpcomingReferralsListPage />} />
                <Route path={AppRoutes.expiredReferrals} element={<ExpiredReferralListPage />} />
                <Route path={AppRoutes.declinedReferrals} element={<DeclinedReferralListPage />} />
                <Route path={AppRoutes.lostReferrals} element={<LostReferralsListPage />} />
                <Route path={AppRoutes.conversationDetails()} element={<ConversationRedirect />} />
                <Route path={AppRoutes.allMessages} element={<AllMessages />} />
                <Route path={AppRoutes.automations} element={<Automations />} />
                <Route path={AppRoutes.automationDetails()} element={<Automations />} />
                <Route path={AppRoutes.prescriberLists} element={<PrescriberLists />} />
                <Route
                    path={AppRoutes.prescriberListDetails()}
                    element={<PrescriberListDetails />}
                />
                <Route path={AppRoutes.stateLists} element={<StateLists />} />
                <Route path={AppRoutes.stateListDetails()} element={<StateListDetails />} />
                <Route path={AppRoutes.userAccounts} element={<UserAccountsListPage />} />
                <Route path={AppRoutes.userAccountCreate} element={<UserAccountFormPage />} />
                <Route path={AppRoutes.userAccountEdit()} element={<UserAccountFormPage />} />
                <Route path={AppRoutes.termsAndConditions} element={<TermsAndConditions />} />
                <Route path={AppRoutes.termsOfUse} element={<TermsOfUse />} />
                <Route path={AppRoutes.privacyPolicy} element={<PrivacyPolicy />} />
                <Route path={AppRoutes.healthPlanNotes} element={<HighmarkWholecarePayerNotes />} />
                <Route path={AppRoutes.updatesHistory} element={<UpdatesHistoryScreen />} />
                <Route path={AppRoutes.knowledgeCenter} element={<KnowledgeCenterPage />} />
            </Route>
            <Route element={<RequireAuth requiredSupplierFeature={SupplierFeatures.MEDBILLING} />}>
                <Route path={AppRoutes.claimSubmissionForm()} element={<ClaimSubmissionForm />} />
                <Route path={AppRoutes.claimsHistory} element={<ClaimsListPage />} />
                <Route path={AppRoutes.claimDetails()} element={<ClaimDetailsPage />} />
            </Route>
            <Route path="*" element={<Navigate replace to={AppRoutes.home} />} />
        </Routes>
    </BrowserRouter>
);
